import { defaultPhoto } from 'assets/images';
import { AvatarFrame, Icon } from 'components';
import { useSpot } from 'hooks';
import { StageActionItem } from 'models';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router';
import { PATH } from 'uniforms';
import { replacePathParams } from 'utils';
import './InfoBoxCustomForAction.scss';

type Props = {
    onClose: () => void;
    data: StageActionItem;
};

/**
 * Info box component
 * @param props
 * @returns
 */
const InfoBoxCustom = (props: Props): JSX.Element => {
    const { data, onClose } = props;
    const navigate = useNavigate();
    const [hover, setHover] = useState<boolean>(false);
    const [isLiked, setIsLiked] = useState<boolean>(false);

    /**
     * handle hover icon
     */
    const handleHoverIcon = useCallback(
        (hover: boolean) => (): void => {
            setHover(hover);
        },
        [],
    );

    /**
     * handle go to detail
     */
    const handleGotoDetail = useCallback(
        (stage_id: number, action_id: number) => (): void => {
            navigate(replacePathParams(PATH.STAGE.STAGE_ACTION_DETAIL, { stage_id: stage_id, action_id: action_id }));
        },
        [navigate],
    );

    return useMemo(
        () => (
            <div className="info-box-container">
                <div className="info-box">
                    <div
                        className="close-btn"
                        onMouseOver={handleHoverIcon(true)}
                        onMouseLeave={handleHoverIcon(false)}
                        onClick={onClose}>
                        {!hover ? <Icon.Close width="24" height="24" /> : <Icon.PressedClose width="24" height="24" />}
                    </div>
                    <div className="d-flex">
                        <div className="first-info-item">
                        </div>
                    </div>
                    <div className="action-item-detail">
                        <img
                            className="image-action"
                            width={64}
                            height={64}
                            src={data.action_photo_url ?? defaultPhoto}
                            alt="action_photo_url"
                            onClick={handleGotoDetail(data.stage_id, data.action_id)}></img>
                        <div>
                            <div className="action-title" onClick={handleGotoDetail(data.stage_id, data.action_id)}>
                                {data.action_title}
                            </div>
                            <div className="action-comment" onClick={handleGotoDetail(data.stage_id, data.action_id)}>
                                {data.action_comment}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="info-box-tail">
                    <Icon.InfoBoxTail />
                </div>
            </div>
        ),
        [
            data.action_photo_url,
            data.action_comment,
            data.stage_id,
            data.action_id,
            data.action_title,
            handleGotoDetail,
            handleHoverIcon,
            hover,
            isLiked,
            onClose,
        ],
    );
};
export default InfoBoxCustom;
